module.exports = __webpack_public_path__ + "assets/logo-default.c730249.png";